import { render } from "./DistributorEdit.vue?vue&type=template&id=5121013a&scoped=true"
import script from "./DistributorEdit.vue?vue&type=script&lang=js"
export * from "./DistributorEdit.vue?vue&type=script&lang=js"

import "./DistributorEdit.vue?vue&type=style&index=0&id=5121013a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5121013a"]])

export default __exports__